import React, { useEffect, useState } from 'react';
import { Formik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { get } from 'lodash';
import { Container, Button, Col, Row } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import { useParams } from 'react-router-dom';
import PageBreadcrumb from '../../common/components/layout/PageBreadcrumb';
import AdminForm from '../form/AdminForm';
import validationSchema from '../form/EditAdminForm.schema';
import { deleteAdmin, editAdmin, fetchAdmin } from '../AdminsActions';
import CommonLoader from '../../common/components/CommonLoader';
import { capitalizeString } from '../../helpers/capitalizeString';

function EditAdminPage() {
  const dispatch = useDispatch();
  const { id } = useParams();
  const adminDetails = useSelector((state) => state.admins.get('adminDetails'));
  const loaderStatus = useSelector((state) => state.admins.get('loaderStatus'));

  const version = get(adminDetails, 'version', null);
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    dispatch(fetchAdmin(id));
  }, [fetchAdmin, id]);

  const handleSubmit = (values, { setSubmitting }) => {
    dispatch(editAdmin(values, id, version));
    setSubmitting(false);
  };

  const breadcrumbs = [
    { id: 1, type: 'home' },
    { id: 2, type: 'link', text: 'Admins', url: '/admins' },
    { id: 3, type: 'span', text: 'Edit Admin' },
  ];

  return (
    <Container fluid>
      <PageBreadcrumb items={breadcrumbs} pageTitle="Edit Admin" />
      <Row>
        <Col md="12">
          <Button
            className="rounded-pill btn-danger float-end mb-2"
            onClick={() => setShowAlert(true)}
          >
            Delete
          </Button>
        </Col>
      </Row>
      <CommonLoader status={loaderStatus}>
        <Formik
          enableReinitialize
          initialValues={{
            ...adminDetails,
            status: {
              value: adminDetails.status,
              label: capitalizeString(adminDetails.status),
            },
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
          validateOnBlur
        >
          {() => <AdminForm title="Edit admin" />}
        </Formik>
      </CommonLoader>
      <SweetAlert
        danger
        showCancel={false}
        showConfirm={false}
        show={showAlert}
        title="Warning!"
        onConfirm={() => {
          setShowAlert(false);
          dispatch(deleteAdmin(id));
        }}
        onCancel={() => setShowAlert(false)}
      >
        {(renderProps) => (
          <div>
            <p>Are you sure to remove this admin?</p>
            <div className="d-flex justify-content-center gap-2 mt-3">
              <Button
                className="rounded-pill btn-soft-primary"
                onClick={() => renderProps.cancel()}
              >
                Cancel
              </Button>
              <Button
                className="rounded-pill btn-primary"
                onClick={() => renderProps.confirm()}
              >
                Yes, Delete
              </Button>
            </div>
          </div>
        )}
      </SweetAlert>
    </Container>
  );
}

export default EditAdminPage;
